<span>
    <span class="preapproval-badge" [hidden]="!foreignCurrency">
        {{ foreignCurrency }}
    </span>
</span>